import styled from 'styled-components';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

const modalPanelSharedPadding = '15px';

export const AccordionContainer = styled.div`
  background: ${({ theme }) => theme.grayLight} !important;
  padding: 0.6rem 0 !important;
  margin: 0 0 1rem !important;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
`;

export const AccordionTitle = styled.h5`
  font-weight: bold !important;
  margin: 0 0 5px 0 !important;
  padding: 0 16px !important;
  /* A font-size será herdada ou definida no tema global, como no exemplo */
`;

export const AccordionDetailsHistory = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff !important;
  margin: 0 10px 0 10px;
  padding: 5px 5px !important;
  /* A borda e o border-radius foram removidos para corresponder ao exemplo */
`;

export const ContainerLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start; /* Mantido do seu código para melhor alinhamento */
`;

export const LabelItem = styled.div`
  color: ${({ theme }) => theme.pantoneBlack};
  font-weight: bold;
  margin: 0 .4rem; /* Aplicado como no exemplo */
  flex-shrink: 0; /* Adicionado para evitar que o label quebre linha */
`;

export const LabelResult = styled.div`
  color: ${({ theme }) => theme.pantoneBlack};
  word-break: break-word; /* Mantido do seu código para textos longos */
`;

export const BoxLabelItem = styled.div`
  margin-bottom: 0.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ModalPanel = styled.div<{ isOpen?: boolean }>`
  position: fixed;
  top: 57px;
  right: ${({ isOpen }) => (isOpen ? '0' : '-400px')};
  width: 380px;
  height: calc(100% - 57px);
  background-color: #f8f9fa;
  border-left: 1px solid #dee2e6;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: ${modalPanelSharedPadding};
  z-index: 1050;
  transition: right 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
`;

export const ModalMainTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
`;

export const DownloadLink = styled.a`
  color: #007bff !important;
  text-decoration: underline !important;
  cursor: pointer;
  &:hover {
    color: #0056b3 !important;
  }
`;

export const ModalContentWrapper = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  margin-bottom: 0;
`;

export const SimpleLinkFallback = styled.a`
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #0056b3;
  }
`;